import { r as registerInstance, c as createEvent, f as forceUpdate, h, g as getElement, H as Host } from './index-5faac9d7.js';
import { c as classnames } from './index-5d9a618b.js';
import { i as isEmpty_1 } from './isEmpty-51908328.js';
import { f as virtualPagesNestedLocations } from './analytics-205f1857.js';
import { d as EQdsButtonSize, c as EQdsButtonImportance } from './currency-7be6806c.js';
import './index-e29b327a.js';
import { s as send, x as productSelectorVirtualPageEvent } from './analytics-b6a65ffa.js';
import './_commonjsHelpers-11ca3be1.js';
import './_nodeUtil-f95b2b52.js';
import './lodash-bd96d09c.js';
import './_Stack-68736bd1.js';
import './number-57a50dcb.js';
import './helpers-e12aa36b.js';

const hmcCardCss = ":host{display:block}.hmc-card{position:relative;display:flex;font-size:14px;line-height:20px;color:#626469}.hmc-card .highlight-naming{font-weight:400}.hmc-card .highlight-naming .accent{font-weight:700}@media screen and (max-width: 979px){.hmc-card{padding:16px}}@media screen and (min-width: 980px){.hmc-card{padding:24px 24px 56px}}.hmc-card--best-match{border:1px solid #3dcd58}@media screen and (min-width: 980px){.hmc-card--best-match{padding:24px}}.hmc-card__img-link-wrapper{cursor:pointer;display:block}@media screen and (max-width: 979px){.hmc-card__img-link-wrapper{height:60px;width:60px}:host(:not([dir=\"rtl\"])) .hmc-card__img-link-wrapper{margin-right:16px}:host([dir=\"rtl\"]) .hmc-card__img-link-wrapper{margin-left:16px}}@media screen and (min-width: 980px){.hmc-card__img-link-wrapper{height:130px}:host(:not([dir=\"rtl\"])) .hmc-card__img-link-wrapper{margin-right:24px}:host([dir=\"rtl\"]) .hmc-card__img-link-wrapper{margin-left:24px}}.hmc-card__img-link-wrapper:hover{cursor:pointer}@media screen and (max-width: 979px){.hmc-card__img{max-height:60px;min-width:60px;max-width:60px}}@media screen and (min-width: 980px){.hmc-card__img{min-width:130px;max-width:130px;max-height:130px}}.hmc-card__text-content{display:flex;flex-direction:column;width:100%}@media screen and (max-width: 979px){.hmc-card__text-content{max-width:calc(100% - 76px)}}@media screen and (min-width: 980px){.hmc-card__text-content{max-width:calc(100% - 154px)}}.hmc-card__text-content-link-wrapper{cursor:pointer;display:flex;flex-direction:column;color:#626469;text-decoration:none}.hmc-card__badge{display:none;margin-bottom:12px}.hmc-card--best-match .hmc-card__badge{display:flex}.hmc-card__title{font-size:16px;line-height:24px;color:#333333;margin:0 0 8px;padding:0;height:100%}.hmc-card__title .highlight-naming{font-weight:400}.hmc-card__title .highlight-naming .accent{font-weight:700}@media screen and (min-width: 980px){:host(:not([dir=\"rtl\"])) .hmc-card__title{padding-right:50px}:host([dir=\"rtl\"]) .hmc-card__title{padding-left:50px}}.hmc-card__text-content-link-wrapper:hover .hmc-card__title,.hmc-card__img-link-wrapper:hover+.hmc-card__text-content .hmc-card__title{text-decoration:underline}.hmc-card__description{overflow:hidden}.hmc-card__master-range-info{margin-top:8px}.hmc-card__text-content-link-wrapper:hover .hmc-card__view-products,.hmc-card__img-link-wrapper:hover+.hmc-card__text-content .hmc-card__view-products{text-decoration:underline}@media screen and (max-width: 979px){.hmc-card__information{display:none}}@media screen and (min-width: 980px){.hmc-card__information{position:absolute;top:24px;width:18px;height:18px;cursor:pointer}:host(:not([dir=\"rtl\"])) .hmc-card__information{right:24px}:host([dir=\"rtl\"]) .hmc-card__information{left:24px}}.hmc-card__tooltip-text{font-size:14px;width:auto;overflow:hidden}.hmc-card__tooltip-title{font-size:14px;line-height:20px;margin-bottom:10px;text-transform:capitalize;font-weight:bold}";

const DESCRIPTION_MAX_HEIGHT = '60px';
const TOOLTIP_MAX_HEIGHT = '298px';
const HmcCard = class {
  handleChangeRangeTooltipInfo() {
    this.tooltipContent = this.getTooltipContent();
  }
  getTooltipContent() {
    const { rangeId } = this.range;
    if (this.rangeTooltipInfo && rangeId in this.rangeTooltipInfo) {
      const { presentation1, presentation2 } = this.rangeTooltipInfo[rangeId];
      return [presentation1, presentation2].filter(Boolean).join(' ');
    }
  }
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.didCloseDialog = createEvent(this, "didCloseDialog", 7);
    this.handleTooltipActivate = () => {
      var _a;
      (_a = this.tooltipContentRef) === null || _a === void 0 ? void 0 : _a.triggerUpdate();
    };
    this.getRangeDescription = () => {
      const { description, longDescription } = this.range;
      return [description, longDescription].filter(Boolean).join(' ');
    };
    this.handleLinkMouseOver = () => {
      this.linkHovered = true;
    };
    this.handleLinkMouseOut = () => {
      this.linkHovered = false;
    };
    this.handleLinkClick = () => {
      this.didCloseDialog.emit();
    };
    this.range = undefined;
    this.isBestMatch = undefined;
    this.labels = undefined;
    this.rangeTooltipInfo = {};
    this.page = 'all-products';
    this.selectorConfig = {};
    this.isPBS = false;
    this.linkHovered = false;
    this.tooltipContent = this.getTooltipContent();
    this.host.dir = document.documentElement.dir || 'auto';
  }
  componentDidLoad() {
    forceUpdate(this.host);
  }
  render() {
    var _a, _b, _c, _d, _e;
    return (h("div", { class: classnames('hmc-card', {
        'hmc-card--best-match': this.isBestMatch,
      }) }, h("pes-router-link", { page: this.page, pageId: this.range.rangeId, url: !this.isPBS ? this.range.selfRef : null, target: "_self", class: "hmc-card__img-link-wrapper" }, h("a", { href: "#", onMouseOver: this.handleLinkMouseOver, onMouseOut: this.handleLinkMouseOut }, h("img", { class: "hmc-card__img", src: this.range.imageUrl, alt: "" }))), h("div", { class: "hmc-card__text-content" }, h("pes-router-link", { page: this.page, pageId: this.range.rangeId, url: !this.isPBS ? this.range.selfRef : null, target: "_self" }, h("a", { class: "hmc-card__text-content-link-wrapper", href: "#", onClick: this.handleLinkClick, onMouseOver: this.handleLinkMouseOver, onMouseOut: this.handleLinkMouseOut }, h("pes-badge", { class: "hmc-card__badge", label: (_a = this.labels) === null || _a === void 0 ? void 0 : _a.bestMatchLabel }), h("h3", { class: "hmc-card__title", innerHTML: this.range.name }), h("pes-ellipsis", { class: "hmc-card__description", maxHeight: DESCRIPTION_MAX_HEIGHT, content: this.getRangeDescription() }), this.range.masterRangeInfo && (h("div", { class: "hmc-card__master-range-info", innerHTML: this.range.masterRangeInfo })), h("pes-hmc-link", { class: "hmc-card__view-products", active: this.linkHovered }, this.range.hasProducts
      ? (_b = this.labels) === null || _b === void 0 ? void 0 : _b.hmcViewProducts
      : (_c = this.labels) === null || _c === void 0 ? void 0 : _c.hmcViewDetails))), h("pes-hmc-product-selector", { functionalIds: this.range.productConfiguratorUrl, selectorConfig: this.selectorConfig, legacyConfiguratorUrl: this.range.legacyConfiguratorUrl, useProductSelectorLabel: (_d = this.labels) === null || _d === void 0 ? void 0 : _d.useProductSelector, selectorHeaderLabel: this.range.name })), this.tooltipContent && (h("pdp-icon-tooltip", { class: "hmc-card__information", icon: "information_stroke", iconSize: "micro", iconColor: "grey", position: "top", onDidOpen: this.handleTooltipActivate }, h("div", { class: "hmc-card__tooltip" }, h("div", { class: "hmc-card__tooltip-title" }, (_e = this.labels) === null || _e === void 0 ? void 0 : _e.featuresLabel), h("pes-ellipsis", { ref: (el) => (this.tooltipContentRef = el), class: "hmc-card__tooltip-text", maxHeight: TOOLTIP_MAX_HEIGHT, content: this.tooltipContent }))))));
  }
  get host() { return getElement(this); }
  static get watchers() { return {
    "rangeTooltipInfo": ["handleChangeRangeTooltipInfo"]
  }; }
};
HmcCard.style = hmcCardCss;

const hmcLinkCss = "@media screen and (min-width: 980px){:host{padding-top:4px}}";

const HmcLink = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.active = false;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  render() {
    return (h(Host, null, h("qds-standalone-link", { size: "standard", importance: "standard" }, h("slot", null))));
  }
  get el() { return getElement(this); }
};
HmcLink.style = hmcLinkCss;

const hmcProductSelectorCss = ".pes-product-selector__link{cursor:pointer}@media screen and (min-width: 980px){.pes-product-selector__link{margin-top:12px}}";

const ProductSelector = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.didOpenProductSelector = createEvent(this, "didOpenProductSelector", 7);
    this.handleOpenProductSelector = (selector, config) => (_) => {
      this.didOpenProductSelector.emit();
      if (config.type === 'sc') {
        const host = document.createElement('pdp-sc-selector-modal');
        const frame = document.createElement('div');
        frame.id = 'widgetFrame';
        host.headerLabel = config.scLabel || this.selectorHeaderLabel || 'Select your product';
        host.appendChild(frame);
        host.open = true;
        host.addEventListener('didClose', () => {
          document.body.removeChild(host);
        });
        document.body.appendChild(host);
      }
      selector.open(config);
      send(productSelectorVirtualPageEvent, {
        location: virtualPagesNestedLocations.HELP_ME_CHOOSE,
      });
    };
    this.openConfigurator = () => {
      window.open(this.legacyConfiguratorUrl, '_blank', 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=yes, resizable=yes, copyhistory=yes, width=1070, height=700');
    };
    this.renderProductSelector = () => {
      const config = Object.assign(Object.assign({}, this.selectorConfig), { scFunctionalIds: this.functionalIds });
      return (h("pes-product-selector", { config: config, renderFunction: (selector) => (h("qds-standalone-link", { size: "standard", importance: "standard", class: "pes-product-selector__link", onClick: this.handleOpenProductSelector(selector, config) }, this.useProductSelectorLabel)) }));
    };
    this.functionalIds = undefined;
    this.selectorConfig = undefined;
    this.legacyConfiguratorUrl = undefined;
    this.useProductSelectorLabel = undefined;
    this.selectorHeaderLabel = undefined;
  }
  render() {
    if ((!this.functionalIds || isEmpty_1(this.selectorConfig)) && !this.legacyConfiguratorUrl) {
      return;
    }
    if (this.functionalIds) {
      return this.renderProductSelector();
    }
    return (h("qds-standalone-link", { size: "standard", importance: "standard", class: "pes-product-selector__link", onClick: this.openConfigurator }, this.useProductSelectorLabel));
  }
};
ProductSelector.style = hmcProductSelectorCss;

const WidgetBackButton = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.didBackButtonClick = createEvent(this, "didBackButtonClick", 7);
    this.handleButtonClick = () => {
      this.didBackButtonClick.emit();
    };
    this.backLabel = undefined;
  }
  render() {
    return (h("qds-standalone-link", { size: EQdsButtonSize.SMALL, importance: EQdsButtonImportance.STANDARD, onClick: this.handleButtonClick, iconName: "chevron-left" }, this.backLabel));
  }
};

const widgetHeaderCss = ".widget-header{font-size:18px;color:#333333;font-weight:bold;margin:20px 0 12px;text-align:center}@media screen and (min-width: 980px){.widget-header{line-height:30px;font-size:22px}}@media screen and (min-width: 980px){.widget-header--large{line-height:40px;font-size:30px;font-weight:normal;margin-top:0}}";

const WidgetHeader = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.isLarge = false;
  }
  render() {
    return (h("h1", { class: classnames('widget-header', {
        'widget-header--large': this.isLarge,
      }) }, h("slot", null)));
  }
};
WidgetHeader.style = widgetHeaderCss;

export { HmcCard as pes_hmc_card, HmcLink as pes_hmc_link, ProductSelector as pes_hmc_product_selector, WidgetBackButton as pes_widget_back_button, WidgetHeader as pes_widget_header };
